// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3dQym","newExpiryDate":"styles_newExpiryDate__3ur2S","footer":"styles_footer__BR-Md"};